import React, { Fragment, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addEducation } from '../../actions/profile';

const AddEducation = ({ addEducation, history }) => {
  const [formData, setFormData] = useState({
    school: '',
    degree: '',
    fieldofstudy: '',
    location: '',
    from: '',
    to: '',
    current: false,
    description: ''
  });

  const [toDateDisabled, toggleDisabled] = useState(false);

  const {
    school,
    degree,
    fieldofstudy,
    location,
    from,
    to,
    current,
    description
  } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <Fragment>
      <h4 className="my-4">Add Your Education</h4>
      <p className="rb">
        <i className="fas fa-code-branch" /> Add any college or university that
        you have attended
      </p>
      <small>* = required field</small>
      <form
        className="mt-3"
        onSubmit={(e) => {
          e.preventDefault();
          addEducation(formData, history);
        }}
      >
        <div className="form-group row">
          <label
            htmlFor="edit-school"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            School
          </label>
          <div className="col-10 col-sm-10 col-md-5">
            <input
              type="text"
              className="form-control form-control-sm"
              aria-describedby="schoolhelp"
              id="edit-school"
              name="school"
              value={school}
              onChange={(e) => onChange(e)}
              required
            />
            <small id="schoolhelp" className="form-text text-muted">
              College, University, or Bootcamp attended
            </small>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="edit-degree"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            Degree
          </label>
          <div className="col-10 col-sm-10 col-md-5">
            <select
              className="custom-select custom-select-sm"
              id="edit-degree"
              name="degree"
              value={degree}
              onChange={onChange}
            >
              <option value="0">Select Degree</option>
              <option value="Associate's">Associate's Degree</option>
              <option value="Bachelor's">Bachelor's Degree</option>
              <option value="Master's">Master's Degree</option>
            </select>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="edit-edu-field"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            Field of Study
          </label>
          <div className="col-10 col-sm-10 col-md-5">
            <input
              type="text"
              className="form-control form-control-sm"
              id="edit-edu-field"
              name="fieldofstudy"
              value={fieldofstudy}
              onChange={(e) => onChange(e)}
            />
            <small id="schoolhelp" className="form-text text-muted">
              ie. 'Marketing', 'Psychology'
            </small>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="edit-edu-location"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            Location
          </label>
          <div className="col-10 col-sm-10 col-md-5">
            <input
              type="text"
              className="form-control form-control-sm"
              id="edit-edu-location"
              name="location"
              value={location}
              onChange={(e) => onChange(e)}
            />
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="edit-edu-from"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            From
          </label>
          <div className="col-10 col-sm-10 col-md-5">
            <input
              type="date"
              className="form-control form-control-sm"
              id="edit-edu-from"
              name="from"
              value={from}
              onChange={(e) => onChange(e)}
            />
          </div>
        </div>
        <div className="form-check currently my-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="edit-edu-current"
            name="current"
            checked={current}
            value={current}
            onChange={() => {
              setFormData({ ...formData, current: !current });
              toggleDisabled(!toDateDisabled);
            }}
          />
          <label className="form-check-label" htmlFor="edit-edu-current">
            Currently enrolled
          </label>
        </div>
        <div className="form-group row">
          <label
            htmlFor="edit-edu-to"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            To
          </label>
          <div className="col-10 col-sm-10 col-md-5">
            <input
              type="date"
              className="form-control form-control-sm"
              id="edit-edu-to"
              name="to"
              value={to}
              onChange={(e) => onChange(e)}
              disabled={toDateDisabled ? 'disabled' : ''}
            />
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="edit-edu-description"
            className="col-sm-2 col-form-label col-form-label-sm"
          >
            Program Description
          </label>
          <div className="col-10 col-sm-10 col-md-5">
            <textarea
              className="form-control form-control-sm"
              id="edit-edu-description"
              rows="2"
              name="description"
              value={description}
              onChange={(e) => onChange(e)}
            ></textarea>
          </div>
        </div>
        <div className="form-group row my-4">
          <div className="col-sm-10">
            <button type="submit" className="btn btn-primary btn-sm mx-3">
              Save
            </button>
            <Link to="/dashboard" className="btn btn-light btn-sm shadow-sm">
              Cancel
            </Link>
          </div>
        </div>
      </form>
    </Fragment>
  );
};

AddEducation.propTypes = {
  addEducation: PropTypes.func.isRequired
};

export default connect(null, { addEducation })(withRouter(AddEducation));
